import * as React from 'react';
import { Check } from 'lucide-react';
import { cx } from '@/lib/utils/cn';

/**
 * CheckRow (`.probe.pick` + `.cbx` in `docs/discovery/prototype/
 * discovery.css`, T-0188): a whole row that toggles a box, for picking
 * questions for a follow-up or the evidence a pain point rests on.
 */
export function CheckRow({
  checked,
  onToggle,
  children,
  disabled = false,
  className,
}: {
  checked: boolean;
  onToggle: () => void;
  children: React.ReactNode;
  disabled?: boolean;
  className?: string;
}) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      disabled={disabled}
      onClick={onToggle}
      className={cx(
        'flex w-full items-start gap-2.5 border-b border-ink-100 py-[7px] text-left text-body-sm text-ink-900 last:border-b-0',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-accent-amber-600',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
    >
      <span
        aria-hidden="true"
        className={cx(
          'mt-0.5 inline-flex h-4 w-4 flex-none items-center justify-center rounded-sm border-[1.5px] text-paper-0',
          checked ? 'border-ink-900 bg-ink-900' : 'border-ink-300 bg-paper-0',
        )}
      >
        {checked ? <Check className="h-3 w-3" strokeWidth={3} /> : null}
      </span>
      <span className="min-w-0 flex-1">{children}</span>
    </button>
  );
}
